import React from 'react';
import { Dialog, Stack } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomButton, CustomDialogTitle, CustomDialogAction, StyledCard, CustomDialogContent } from '../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';

const ChecklistRemarkModal = ({ children, ...props }) => {
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'remark'} onClose={props.onClose}>
        <CustomDialogTitle id='form-dialog-title'>
          Remark
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form className={styles.w100}>
          <CustomDialogContent sx={{ width: 600 }}>
            <StyledCard>
              {children}
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction>
            <Stack direction='row' justifyContent='space-between' spacing={2} className={styles.w100}>
              <CustomButton variant='contained' onClick={props.onClose}>Close</CustomButton>
              <CustomButton variant='contained' onClick={props.onSubmit}>Submit</CustomButton>
            </Stack>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default ChecklistRemarkModal;